import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page Not Found | HealthGonia</title>
        <meta
          name="description"
          content="The page you are looking for does not exist. Go back to HealthGonia home or continue shopping."
        />
      </Helmet>

      <div className="main not-found-page">
        <section className="not-found-content common-padding">
          <p className="not-found-code">404</p>
          <h1>Oops! We could not find that page.</h1>
          <p className="not-found-text">
            The link may be broken or the page may have been moved.
          </p>
          <div className="not-found-actions">
            <Link to="/" className="cutsom-bttn">
              Back to Home
            </Link>
            <Link to="/products" className="cutsom-bttn transparent-bttn">
              Browse Products
            </Link>
          </div>
        </section>
      </div>
    </>
  );
}

export default NotFound;
